import { SVGProps } from 'react';

const ListCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 18H3m12 0 2 2 4-4m-5-4H3m13-6H3"
    />
  </svg>
);
export default ListCheck;
